<template>
  <div>
    <checkbox-card
      v-if="isCashAllowed"
      v-model="method"
      type="radio"
      input-value="cash"
    >
      {{ $t('enums.payment_method.cash') }}
    </checkbox-card>
    <div v-if="isCardAllowed">
      <checkbox-card
        v-if="showCardMethodCheckbox"
        v-model="method"
        type="radio"
        input-value="card"
      >
        {{ $t('enums.payment_method.card') }}
      </checkbox-card>
      <checkbox-card
        v-for="(card, index) in cards"
        :key="index"
        v-model="cardId"
        :input-value="card.id"
        type="radio"
      >
        <b>{{ card.brand }}</b>
        **** **** ****
        {{ card.last4 }}
        ({{ card.exp_month }}/{{ card.exp_year }})
      </checkbox-card>
      <div class="mb-4">
        <add-form
          v-if="$account"
          v-show="showCardForm"
          ref="cardForm"
          @saved="cardSaved"
          @cancelled="addCardCancelled"
        />
        <b-button
          v-show="showAddCardButton"
          type="button"
          variant="primary"
          @click="addNewCard"
        >
          {{ $t('general.add_new') }}
        </b-button>
      </div>
    </div>
    <checkbox-card
      v-if="isBancontactAllowed"
      v-model="method"
      type="radio"
      input-value="bancontact"
    >
      {{ $t('enums.payment_method.bancontact') }}
    </checkbox-card>
  </div>
</template>

<script>
import CheckboxCard from '../components/CheckboxCard'
import AddForm from '../mycards/CardForm.vue'

export default {
  name: 'PaymentMethodChoice',
  components: { AddForm, CheckboxCard },

  props: {
    allowedMethods: {
      type: Array,
      required: true,
    },
    selectedMethod: {
      type: String,
      required: false,
      default: () => {
        return 'cash'
      },
    },
  },

  emits: ['change'],

  data() {
    return {
      method: null,
      cardId: null,
      cards: [],
      showCardForm: false,
    }
  },

  computed: {
    isCashAllowed() {
      return this.isAllowed('cash')
    },
    isBancontactAllowed() {
      return this.isAllowed('bancontact')
    },
    isCardAllowed() {
      return this.isAllowed('card')
    },
    showAddCardButton() {
      return (
        !this.showCardForm &&
        this.isCardAllowed &&
        (this.method === 'card' || this.cards.length > 0)
      )
    },
    showCardMethodCheckbox() {
      return this.isCardAllowed && this.cards.length === 0 && !this.showCardForm
    },
  },

  watch: {
    cardId(newVal) {
      if (newVal) {
        this.method = 'card'
        this.changeEvent()
      }
    },
    method(newVal) {
      if (newVal !== 'card') {
        this.cardId = null
        this.changeEvent()
      } else {
        this.showCardForm = this.cards.length === 0
      }
    },
  },

  mounted() {
    this.method = this.selectedMethod
    this.$uiBlocker(
      this.$http.get('cards').then((result) => {
        this.cards = result.data.data
        if (this.cards.length === 0 && this.method === 'card') {
          this.showCardForm = true
        }
      })
    )
  },

  methods: {
    isAllowed(method) {
      return this.allowedMethods.indexOf(method) !== -1
    },
    cardSaved(card) {
      this.cards.push(card)
      this.showCardForm = false
      this.cardId = this.cards[this.cards.length - 1].id
    },
    changeEvent() {
      this.$emit('change', {
        method: this.method,
        payload: {
          cardId: this.cardId,
          stripe: this.$refs.cardForm.stripe,
        },
      })
    },
    addNewCard() {
      this.showCardForm = true
    },
    addCardCancelled() {
      this.showCardForm = false
    },
  },
}
</script>
